import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
// import "../../../Style/customer_v2.scss";

//API
import ItemService from "../../../../services/customer_appCommonService";

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import Constants from "../../../../common/SupplierConstants";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import {
  getTodaysData,
  validateBankAccount,
  validateContactNumber,
  validateEmail,
  validateName,
  validateRequired,
  validPostalCode,
} from "../../../../common/Validations";
// import CustomerConstants from "../../../../common/CustomerConstants";
import toast from "react-hot-toast";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import {
  companyCodeDropDownOptions, 
  message,
  dropdownOption,
  // employeeGender,
  failureModalData,
  vendorCategoryData,
} from "../CustomerV5Constant/MRSupplierConstant";
// import CustomerConstants from "../../../../common/CustomerConstants";

const SupplierSelfRegistrationMr = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //   localStorage.setItem("menu", "Employee");
  //   localStorage.setItem("submenu", "Employee Master");

  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data);
  // let requiredFields = [];

  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  // const [isCardVisible9, setCardVisible9] = useState(false);

  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);

  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);

  const [getdocumentType, setdocumentType] = useState([]);
  // eslint-disable-next-line
  const [showOtherRoleInput, setShowOtherRoleInput] = useState(false);

  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [validation, setValidation] = useState({});
  console.log(">>validation", validation);

  //bank state
  const [getBankDetails, setBankDetails] = useState([]);
  const [getBankDetailsData, setBankDetailsData] = useState([]);
  // const [getCompanyCode, setCompanyCode] = useState([]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  // const toggleCardVisibility9 = () => {
  //   setCardVisible9(!isCardVisible9);
  // };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    validateName(name === "employeeName" ? value : "")
      ? (errors.employeeName = "")
      : (errors.employeeName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

    if (name === "email") {
      if (!validateRequired(value)) {
        errors.email = message.FILL_REQUIRED_FIELD;
      } else if (!validateEmail(value)) {
        errors.email = message.VALID_MAIL_ID;
      }
    }

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    employeeName: "",
    address: "",
    address2: "",
    city: "",
    country: "IN - India",
    state: "IN - Karnataka",
    cityPostalCode: "",
    companyCode: "",

    version: "v0",
    status: "Registered",
    category: "VENDOR",
    // registerType: "Employee",
    type: "SUPPLIER",
    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    joiningDate: getTodaysData(),
    vendorCategory: "",
    vendorCategoryCode: "",
    vendorCategoryDesc: "",
    email: "",

    plantAddress: appConfig?.customerPlantAddress,
    projectLocation: "",

    // customerTypeCode: "C03",
    // customerTypeDesc: "Domestic",

    jobRole: "",
    otherJobRole: "",
  });

  const [getCustomerTypeCode, setCustomerTypeCode] = useState();
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    getMasterData();
  }, [dispatch]);

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else if (getDropdownData?.textField === "vendorCategory") {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name, // Sets "vendorCategory"
        [getDropdownData?.textCode]: getDropdownData?.code, // Sets "vendorCategoryCode"
        [getDropdownData?.textDesc]: getDropdownData?.description, // Sets "vendorCategoryDesc"
      }));
    } else if (getDropdownData?.textDesc === "jobRoleDesc") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setCustomerTypeCode(getDropdownData?.code);
    // } else if (getDropdownData?.textField === "employeeGender") {
    //   setFormInputs((formInputs) => ({
    //     ...formInputs,
    //     [getDropdownData?.textField]: getDropdownData?.name,
    //     [getDropdownData?.textCode]: getDropdownData?.code,
    //     [getDropdownData?.textDesc]: getDropdownData?.description,
    //   }));
    } else if (getDropdownData?.textField === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // getStateData(getDropdownData?.code);
    } else if (getDropdownData?.textCode === "salesOfficerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc
        )
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc
        )
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc
        )
      );
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  useEffect(() => {
    if (getDropdownData?.textCode === "jobRoleCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));

      // Show input only if code is "4" (Others)
      if (getDropdownData?.code === "4") {
        setShowOtherRoleInput(true);
      } else {
        setShowOtherRoleInput(false);
        setFormInputs((prev) => ({
          ...prev,
          otherJobRole: "",
        }));
      }
    }

    // Other conditions remain unchanged...

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
  }, [getDropdownData]);

  // SAVE

  const handleSave = async () => {
    const requiredFields = [];
    let hasError = false;

    const validationErrors = {};

    if (!validateRequired(formInputs.employeeName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        employeeName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateName(formInputs.employeeName)) {
      requiredFields.push(`${message.VALID_CUSTOMER_NAME}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        employeeName: message.VALID_CUSTOMER_NAME,
      }));
      return;
    }
    if (!validateRequired(formInputs.mobileNr)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        mobileNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateContactNumber(formInputs.mobileNr)) {
      requiredFields.push(`${message.MOBILE_NUMBER}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        mobileNr: message.MOBILE_NUMBER,
      }));
      return;
    }
    if (!validateRequired(formInputs.email)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        email: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateEmail(formInputs.email)) {
      requiredFields.push(`${message.VALID_MAIL_ID}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        email: message.VALID_MAIL_ID,
      }));
      return;
    }

    // if (!validateRequired(formInputs.employeeGender)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     employeeGender: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    if (!validateRequired(formInputs.address)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        address: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.address2)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        address2: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs?.country)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        country: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs?.city)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        city: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.cityPostalCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        cityPostalCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validPostalCode(formInputs.cityPostalCode)) {
      requiredFields.push(`${message.VALID_POSTAL_CODE}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        cityPostalCode: message.VALID_POSTAL_CODE,
      }));
      return;
    }

    // Validation for Vendor Category
    if (!validateRequired(formInputs.vendorCategoryCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        vendorCategory: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    getcustomerContactPerson.forEach((doc) => {
      const id = doc.id;

      if (!doc.contactPosition) {
        validationErrors[`${id}_contactPosition`] = message.FILL_REQUIRED_FIELD;
        // requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        hasError = true;
      }
      if (!doc.contactTitle) {
        validationErrors[`${id}_contactTitle`] = message.FILL_REQUIRED_FIELD;
        // requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        hasError = true;
      }

      if (!doc.contactName) {
        validationErrors[`${id}_contactName`] = message.FILL_REQUIRED_FIELD;
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        hasError = true;
      } else if (!validateName(doc.contactName)) {
        validationErrors[`${id}_contactName`] = message.VALID_CUSTOMER_NAME;
        requiredFields.push(`${message.VALID_CUSTOMER_NAME}`);
        hasError = true;
      }

      // if (!doc.contactEmail) {
      //   validationErrors[`${id}_contactEmail`] = message.FILL_REQUIRED_FIELD;
      //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      //   hasError = true;
      // } else if (!validateEmail(doc.contactEmail)) {
      //   validationErrors[`${id}_contactEmail`] = message.VALID_MAIL_ID;
      //   requiredFields.push(`${message.VALID_MAIL_ID
      //   }`);
      //   hasError = true;
      // }

      if (!doc.contactNumber) {
        validationErrors[`${id}_contactNumber`] = message.FILL_REQUIRED_FIELD;
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        hasError = true;
      } else if (!validateContactNumber(doc.contactNumber)) {
        validationErrors[`${id}_contactNumber`] = message.VALID_CONTACT_NUMBER;
        requiredFields.push(`${message.VALID_MAIL_ID}`);
        hasError = true;
      }
    });

    getDocumentTypeData.forEach((doc) => {
      const id = doc.id;
      if (!doc.documentNumber) {
        validationErrors[`${id}_documentType`] = message.FILL_REQUIRED_FIELD;
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        hasError = true;
      }
      if (!doc.documentNumber) {
        validationErrors[`${id}_documentNumber`] = message.FILL_REQUIRED_FIELD;
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        hasError = true;
      }
    });

    getBankDetails.forEach((doc) => {
      const id = doc.id;
        if (!doc.bankAccountNumber) {
          validationErrors[`${id}_bankAccountNumber`] =
            message.FILL_REQUIRED_FIELD;
          requiredFields.push(message.FILL_REQUIRED_FIELD);
          hasError = true;
        } else if (!validateBankAccount(doc.bankAccountNumber)) {
          validationErrors[`${id}_bankAccountNumber`] = message.VALID_BANK_ACC;
          requiredFields.push(message.VALID_BANK_ACC);
          hasError = true;
        }

        if (!doc.bankIFSC) {
          validationErrors[`${id}_bankIFSC`] = message.FILL_REQUIRED_FIELD;
          requiredFields.push(message.FILL_REQUIRED_FIELD);
          hasError = true;
        }
        if (!doc.AccountHolderName) {
          validationErrors[`${id}_AccountHolderName`] =
            message.FILL_REQUIRED_FIELD;
          requiredFields.push(message.FILL_REQUIRED_FIELD);
          hasError = true;
        }

});

    // Set validation state only once
    setValidation((prev) => ({
      ...prev,
      ...validationErrors,
    }));

    const anyFieldHasError = Object.values(validationErrors).some(
      (val) => val !== null && val !== ""
    );

    if (hasError || anyFieldHasError) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    formInputs.firstName = formInputs.employeeName;
    formInputs.contactDetails = getcustomerContactPerson;
    formInputs.certifications = getDocumentTypeData;
    formInputs.bandkDetails = getBankDetails;
    formInputs.customerTypeCode = getCustomerTypeCode;
    formInputs.disableWorkFlow = true;
    formInputs.customerTypeCode = "S01";
    formInputs.organisationName = formInputs.employeeName;

    const obj = {
      data: formInputs,
    };
    // console.log(">>obj", obj);
    setDisabled(true);
    await ItemService.addSelfSupplier(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(
          item?.message || "Registration successful! We'll contact you soon.",
          {
            duration: 5000,
            position: "top-right",
          }
        );

        setTimeout(() => navigate("/"), 3000);

        // dispatch(saveCustomerRegData(item?.data));
        // navigate(CustomerConstants.CUSTOMER_V2_CUSTOMER_MASTER_LIST);

        // console.log(">> userData");

        // if(userData){
        //   navigate(CustomerConstants.CUSTOMER_V1_COSTING_SHEET);
        //   dispatch(saveCustomerRegData(item?.data));
        // }else{
        //   navigate(CustomerConstants.CUSTOMER_V1_COSTING_SHEET_LOGIN);
        //   dispatch(saveCustomerRegData(item?.data));
        // }
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  useEffect(() => {
    // Reset validation when new data is loaded
    setValidation({});
  }, [getcustomerContactPerson]);

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
    // let obj4 = {
    //   codeType: "companyCode",
    // };
    // await ItemService.getMasterData(obj4).then((item) => {
    //   // console.log('>> item!',item);
    //   if (item?.status === 200) {
    //     setCompanyCode(item?.data);
    //   } else {
    //     setCompanyCode([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });
  };
  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    // let obj4 = {
    //   type: "ALL",
    // };
    // await ItemService.getCustomers(obj4).then((item) => {
    //   // console.log(">> item! title", item);
    //   if (item?.status === 200) {
    //     setCustomer(item?.data);
    //   } else {
    //     setCustomer([]);
    //     console.log(">> Error: Loading getCustomers");
    //   }
    // });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const navigateToLogin = () => {
    navigate(Constants.LOGIN);
  };

  /* ---------------------Customer Contact Person -------- */

  const deleteCustomerContactPerosn = (id) => {
    const updatedData1 = getcustomerContactPerson.filter(
      (doc) => doc.id !== id
    );
    setcustomerContactPerson(updatedData1);
  };
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };

  const handleChangeCustomerContacts = (id, fieldName, value) => {
    const errors = {};

    // Required field validation
    if (!validateRequired(value)) {
      errors[fieldName] = `${fieldName} is required.`;
    }

    // Contact number format validation
    if (fieldName === "contactNumber" && validateRequired(value)) {
      if (!validateContactNumber(value)) {
        errors[fieldName] = "Invalid contact number. Must be 10 digits.";
      }
    }
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
    // Update validation state
    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };

  /* ---------------------Document Type  03rd block-------- */

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  const handleInputChange = (id, fieldName, value) => {
    const errors = {};

    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc
      )
    );
  };

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //bank start

  const bankInfoInitialData = {
    id: "",
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "INR",
  };

  //Load Bank Master Data
  const getBankMasterData = async () => {
    await ItemService.getBankMasterData().then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setBankDetailsData(item?.data);
      } else {
        setBankDetailsData([]);
        console.log(">> Error: Loading getBankMasterData");
      }
    });
  };
  useEffect(() => {
    getBankMasterData(); // Load Bank Details
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Bank Info Section
  // const addBankForm = () => {
  //   setBankDetails([...getBankDetails, bankInfoInitialData]); // Add an empty object to the forms array
  // };
  // const addBankForm = () => {
  //   const uniqueId = Date.now().toString(); // or use uuid if you prefer
  //   const newForm = { ...bankInfoInitialData, id: uniqueId };
  //   setBankDetails([...getBankDetails, newForm]);
  // };
  const addBankForm = () => {
    const newForm = {
      ...bankInfoInitialData,
      id: Date.now().toString(),
    };
    setBankDetails((prev) => [...prev, newForm]);
  };

  const removeBankForm = (indexToRemove) => {
    setBankDetails(
      getBankDetails.filter((form, index) => index !== indexToRemove)
    );
  };

  // useEffect(() => {
  //   setBankDetails([...getBankDetails, bankInfoInitialData]);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    setBankDetails([
      {
        ...bankInfoInitialData,
        id: Date.now().toString(),
      },
    ]);
    // eslint-disable-next-line
  }, []);

  // const handleChangeBankInfo = (id, key, value) => {
  //   const updatedBankDetails = getBankDetails.map((item) => {
  //     if (item.id === id) {
  //       return {
  //         ...item,
  //         [key]: value,
  //         ...(key === "bankKey" &&
  //           (() => {
  //             const selectedBank = getBankDetailsData.find(
  //               (bank) => bank.name === value
  //             );
  //             return selectedBank
  //               ? {
  //                   bankCountryDescription: selectedBank.bankCountryDescription,
  //                   bankAccountName: selectedBank.bankAccountName,
  //                   bankAddress: selectedBank.bankAddress,
  //                   bankBranchName: selectedBank.bankBranchName,
  //                   bankCurrency: selectedBank.bankCurrency,
  //                 }
  //               : {};
  //           })()),
  //       };
  //     }
  //     return item;
  //   });

  //   setBankDetails(updatedBankDetails);

  //   // Validate
  //   const errorMsg = !value ? `${key} is required.` : "";

  //   setValidation((prev) => ({
  //     ...prev,
  //     [`${id}_${key}`]: errorMsg,
  //   }));
  // };
  const handleChangeBankInfo = (id, key, value) => {
  setBankDetails((prev) =>
    prev.map((item) => {
      if (item.id !== id) return item;

      let updatedItem = {
        ...item,
        [key]: value,
      };

      // Auto-fill when bankKey changes
      if (key === "bankKey") {
        const selectedBank = getBankDetailsData.find(
          (bank) => bank.name === value
        );

        if (selectedBank) {
          updatedItem = {
            ...updatedItem,
            bankCountryDescription: selectedBank.bankCountryDescription,
            bankAccountName: selectedBank.bankAccountName,
            bankAddress: selectedBank.bankAddress,
            bankBranchName: selectedBank.bankBranchName,
            bankCurrency: selectedBank.bankCurrency,
          };
        }
      }

      return updatedItem;
    })
  );
};

  const onSuccessUploadBankDocumentType = (data, index) => {
    const updatedBankDetails = [...getBankDetails];
    updatedBankDetails[index][data.fieldName] = data.attachmentId;
    setBankDetails(updatedBankDetails);
  };

  return (
    <main className="dashboard px-2 mt-2 border-1 border-lightGray">
      {/* <Layout /> */}
      <Row className="justify-center">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Vendor Registration</h2>
            <p className="subText">
              Register as a new Vendor or Sub-Vendor with our Company
            </p>
            <hr />
            <Row className="mb-4">
              <Col
                xs={12}
                md={{ span: 2, offset: 10 }}
                lg={{ span: 2, offset: 10 }}
                className="text-left"
              >
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
            </Row>
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">S</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Vendor </span>
                      <span className="subHeaderTitle">Vendor Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vendor Name"
                          name="employeeName"
                          placeholder=""
                          value={formInputs?.employeeName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation?.employeeName}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Mobile"
                          name="mobileNr"
                          type="number"
                          placeholder=""
                          value={formInputs.mobileNr || ""}
                          onChange={onInputChange}
                          error={validation.mobileNr}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Email"
                          name="email"
                          required={true}
                          placeholder="Enter Your Email Id"
                          value={formInputs.email || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Gender"
                          name="employeeGender"
                          code="employeeGenderCode"
                          description="employeeGenderDesc"
                          data={employeeGender}
                          id="employeeGender"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.employeeGender}
                          error={validation?.employeeGender}
                          getvalue={setDropdownData} // This should update getDropdownData
                          required={true}
                        />
                      </Col> */}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label=" Address Lines 1 / Street"
                          name="address"
                          placeholder=""
                          value={formInputs?.address || ""}
                          onChange={onInputChange}
                          error={validation?.address}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 2"
                          name="address2"
                          placeholder=""
                          value={formInputs?.address2 || ""}
                          onChange={onInputChange}
                          error={validation?.address2}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="City"
                          name="city"
                          placeholder=""
                          value={formInputs.city || ""}
                          onChange={onInputChange}
                          error={validation.city}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Country"
                          placeholder=""
                          data={getCountry}
                          id="country"
                          iconClassName="dropdownIcon"
                          name="country"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs?.country}
                          getvalue={setDropdownData}
                          required={true}
                          // error={validation.country}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="State"
                          placeholder=""
                          data={getState}
                          id="state"
                          iconClassName="dropdownIcon"
                          name="state"
                          code="stateCode"
                          description="stateDesc"
                          setValue={formInputs.state}
                          getvalue={setDropdownData}
                          required={true}
                          // error={validation.state}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Postal Code/PO Box"
                          name="cityPostalCode"
                          placeholder=""
                          value={formInputs.cityPostalCode}
                          onChange={onInputChange}
                          error={validation.cityPostalCode}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Vendor Category"
                          name="vendorCategory"
                          code="vendorCategoryCode"
                          description="vendorCategoryDesc"
                          data={vendorCategoryData}
                          id="vendorCategory"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.vendorCategory}
                          error={validation?.vendorCategory}
                          getvalue={setDropdownData} // This should update getDropdownData
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Code"
                          name="companyCode"
                          code="companyCodeCode"
                          description="companyCodeDesc"
                          data={companyCodeDropDownOptions}
                          id="companyCode"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.companyCode}
                          error={validation?.companyCode}
                          getvalue={setDropdownData} // This should update getDropdownData
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          min="2000-01-01"
                          label="Joining Date"
                          name="joiningDate"
                          id="joiningDate"
                          value={formInputs?.joiningDate || ""}
                          onChange={onInputChange}
                          // disabled={true}
                        />
                      </Col>
                      {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                        >
                          <div>
                            <label
                              className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                              htmlFor="activeInactive"
                            >
                              Active/Inactive
                            </label>
                          </div>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input custom-switch"
                              type="checkbox"
                              role="switch"
                              name="activeInactive"
                              id="activeInactive"
                              checked={formInputs?.activeInactive || false}
                              onChange={(e) =>
                                setFormInputs((prev) => ({
                                  ...prev,
                                  activeInactive: e.target.checked,
                                }))
                              }
                              // disabled={editMode}
                            />
                            <span className="ms-2">
                              {formInputs?.activeInactive ? "Active" : "Inactive"}
                            </span>
                          </div>
                        </Col> */}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Contact Person</span>
                      <span className="subHeaderTitle">
                        Customer Contact Person
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          onClick={addCustomerCantactPerson}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Job Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Person
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Email-ID
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getcustomerContactPerson.map(
                                      (doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Job Title"
                                              data={getcontactPosition}
                                              id="contactPosition"
                                              iconClassName="dropdownIcon"
                                              name="contactPosition"
                                              code="contactPositionCode"
                                              description="contactPositionDesc"
                                              setValue={doc?.contactPosition}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactPosition`
                                                ]
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Contact Title"
                                              data={getTitle}
                                              id="contactTitle"
                                              iconClassName="dropdownIcon"
                                              name="contactTitle"
                                              code="contactTitleCode"
                                              description="contactTitleDesc"
                                              setValue={doc?.contactTitle}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactTitle`
                                                ]
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactName"
                                              placeholder="Contact Person"
                                              value={doc.contactName || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactName",
                                                  e.target.value
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactName`
                                                ]
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactNumber"
                                              placeholder="Contact Number"
                                              value={doc.contactNumber || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactNumber",
                                                  e.target.value
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactNumber`
                                                ]
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              // label="Please Enter the Remarks*"
                                              name="contactEmail"
                                              placeholder="Email"
                                              value={doc.contactEmail || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactEmail",
                                                  e.target.value
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactEmail`
                                                ]
                                              }
                                            />
                                          </Col>

                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={1}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <i
                                              onClick={() =>
                                                deleteCustomerContactPerosn(
                                                  doc.id
                                                )
                                              }
                                              className="bi bi-trash text-danger fs-4 cursor-pointer"
                                              title="Delete Contact"
                                            />
                                          </Col>
                                        </Row>
                                      )
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Document Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Document Type</span>
                      <span className="subHeaderTitle">Document Type</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button className="btnTable" onClick={addDocumentType}>
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      {/* <Col xs={12} md={4} lg={2}>
                                          <p className="fs-6 fw-medium d-flex ms-4">
                                            Issuing Authority
                                          </p>
                                        </Col> */}
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={handleInputChange}
                                            error={
                                              validation[
                                                `${doc.id}_documentType`
                                              ]
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value
                                              )
                                            }
                                            error={
                                              validation[
                                                `${doc.id}_documentNumber`
                                              ]
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            min="2000-01-01"
                                            type="date"
                                            value={doc.issueDate}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {(doc.iSOCertification && (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification
                                                  )
                                                }
                                              />
                                            )) ||
                                              "--"}
                                          </div>
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            label=""
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={false} // Change to `false` for single file selection
                                            required={true}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <i
                                            onClick={() =>
                                              deleteDocumentType(doc.id)
                                            }
                                            className="bi bi-trash text-danger fs-4 cursor-pointer"
                                            title="Delete Document"
                                          />
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* 08 Banker Info*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BI</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Bank Information</span>
                      <span className="subHeaderTitle">
                        Bank Information (Please add all your Bank Accounts)
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={() => addBankForm()}
                          // disabled={getDisabledStatus}
                        >
                          <i className="bi bi-plus-lg"></i> Add Bank Info
                        </button>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col>
                  </Row>
                </h2>

                {/* Banker Information */}
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {/* To Load Dynamic Bank Info Form */}
                    {getBankDetails &&
                      getBankDetails?.map((item, index) => (
                        <div key={item.id}>
                          <Row className="pt-2 pb-2">
                            <Col
                              xs={10}
                              md={10}
                              lg={10}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h6>Bank Information Section {index + 1}</h6>
                              </Col>
                              <Col 
                              xs={2}
                              md={2}
                              lg={2}
                              className="commTopButtonRightLeftPadding"
                              >
                              <span
                                className="deleteIconAccordion cursor-pointer text-danger mt-1"
                                onClick={() => removeBankForm(index)}
                                title="Remove Bank Section"
                              >
                                <i className="bi bi-x-circle fs-4"></i>
                              </span>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank IFSC ID"
                                name="bankIFSC"
                                placeholder=""
                                value={item?.bankIFSC}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankIFSC",
                                    e.target.value
                                  )
                                }

                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank A/C Number"
                                name="bankAccountNumber"
                                placeholder=""
                                value={item?.bankAccountNumber}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankAccountNumber",
                                    e.target.value
                                  )
                                }
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_bankAccountNumber`]
                                    : ""
                                }
                                disabled={false}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank Name"
                                name="bankBranchName"
                                placeholder=""
                                value={item?.bankBranchName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankBranchName",
                                    e.target.value
                                  )
                                }
                                disabled={false}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank Country"
                                name="bankCountry"
                                placeholder=""
                                value={item?.bankCountry}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankCountry",
                                    e.target.value
                                  )
                                }
                                disabled={false}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Branch Address"
                                name="bankAddress"
                                placeholder=""
                                value={item?.bankAddress}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankAddress",
                                    e.target.value
                                  )
                                }
                                disabled={false}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Preferred Currency"
                                name="bankCurrency"
                                placeholder=""
                                value={item?.preferredCurrency}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankCurrency",
                                    e.target.value
                                  )
                                }
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name of Beneficiary"
                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                name="AccountHolderName"
                                placeholder=""
                                value={item?.AccountHolderName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "AccountHolderName",
                                    e.target.value
                                  )
                                }
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_AccountHolderName`]
                                    : ""
                                }
                                disabled={false}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="IFSC Code"
                                placeholder=""
                                data={dropdownOption}
                                id="swiftIfscCode"
                                iconClassName="dropdownIcon"
                                name="swiftIfscCode"
                                setValue={item?.swiftIfscCode || ""}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <FileUploadComponent
                                  id="bankCompanyletterhead"
                                  name="bankCompanyletterhead"
                                  label="Company letterhead"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={false} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={(data) =>
                                    onSuccessUploadBankDocumentType(data, index)
                                  }
                                  value={item?.bankCompanyletterhead || ""}
                                />

                                <div className="d-flex align-items-center pe-2">
                                  {(item?.bankCompanyletterhead && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.bankCompanyletterhead
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                <FileUploadComponent
                                  id="bankConfirmationLetter"
                                  name="bankConfirmationLetter"
                                  label="Confirmation letter"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={false} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={(data) =>
                                    onSuccessUploadBankDocumentType(data, index)
                                  }
                                  value={item?.bankConfirmationLetter || ""}
                                />

                                <div className="d-flex align-items-center pe-2">
                                  {(item?.bankConfirmationLetter && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.bankConfirmationLetter
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>
                            </Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <hr />
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col
          xs={12}
          md={{ span: 2, offset: 10 }}
          lg={{ span: 2, offset: 10 }}
          className="text-left"
        >
          <button className="btnTable" onClick={handleSave} disabled={disabled}>
            <i className="bi bi-save"></i> Create
          </button>
        </Col>
      </Row>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default SupplierSelfRegistrationMr;
